import React from 'react';
import './account.scss';

const Account = ({ children }) => (
  <div className="main-container">
    <div className="registration-container">{children}</div>
  </div>
);



export default Account;
